import React, { useEffect } from 'react';
import {
    Container,
    Button,
    Col,
    Row,
} from "react-bootstrap";
import { LinkContainer } from 'react-router-bootstrap'

export default function TwoOptions(props) {
    console.log(props);
    const position = props.position;
    const emirate = props.emirate;
    
    useEffect(() => {
    
    });

   return (
      <Container fluid="lg">
          <Row>
            <Col>
            <LinkContainer to={{
                                pathname: `/clinics/${emirate.toLowerCase()}`,
                                state: {emirate, position}
            }}>
                <Button className='my-2 py-5' block><h2>Book an appointment now</h2></Button>
            </LinkContainer>
            </Col>

            <Col>
            <LinkContainer to={{
                                pathname: `/clinics/${emirate.toLowerCase()}`,
                                state: {emirate, position, activeTab: 'clinics'}
            }}>
                <Button className='my-2 py-5' block><h2>Find your personal dentist</h2></Button>
            </LinkContainer>
            </Col>
          </Row>
      </Container>
    );

}